import React from "react";
import DragHandle from "@material-ui/icons/DragHandle";
import { FormControlLabel, Card, Checkbox } from "@material-ui/core";
import { MetricsSwitch } from "./metrics-switch";
import { MetricToggle, MetricToggleKey } from "./types";
import { merge, $ } from "glamor";
import { DATATEST } from "constants/integration";
import { Metric, MetricsKind } from "helpers/metrics/types";
import { isMetricSelected } from "./metrics-helpers";
import { ToggleMetric, ToggleSwitch } from "actions/tool-panel/draft/types";

export type PassedProps = {
    label: string;
    metric: Metric;
    index: number;
    isRollupMode: boolean;
    rollupAverageUnitsEnabled: boolean;
    toggleShowOn: () => void;
};

type ReduxProps = {
    toggleMetric: ToggleMetric;
    toggleSwitch: ToggleSwitch;
};

const styles = merge(
    $(" .form-label svg", {
        fontSize: "2rem",
    }),
    $(" .drag-handle", {
        cursor: "pointer",
        color: "gray",
        marginLeft: "6px",
        marginRight: "-8px",
    })
);
export const MetricsSection = (props: PassedProps & Partial<ReduxProps>) => {
    const { label, metric, index, toggleMetric, toggleSwitch, rollupAverageUnitsEnabled, isRollupMode } = props;
    const disableMetric = rollupAverageUnitsEnabled && isRollupMode && metric.kind !== MetricsKind.AVERAGE_UNITS;

    const show = isMetricSelected(metric);

    return (
        <Card {...styles} className="section">
            <div className="header" data-test={DATATEST.TOOL_PANEL.DOORS.METRICS.HEADER}>
                <DragHandle className="drag-handle" />
                <FormControlLabel
                    className="form-label"
                    control={
                        <Checkbox
                            disabled={disableMetric}
                            color="primary"
                            checked={show}
                            onClick={() => {
                                toggleMetric({ index });
                            }}
                        />
                    }
                    label={label}
                />
            </div>
            {show &&
                Object.keys(MetricToggle).map((toggle: MetricToggleKey) => {
                    const checked = metric[toggle];
                    const label = MetricToggle[toggle];
                    return (
                        <MetricsSwitch
                            key={toggle}
                            className="form-label section-switch"
                            dataTestName={DATATEST.TOOL_PANEL.DOORS.METRICS.SWITCH}
                            checked={checked}
                            onChange={() => toggleSwitch({ index, toggle })}
                            label={label}
                            labelPlacement="start"
                            disableMetric={disableMetric}
                        />
                    );
                })}
        </Card>
    );
};
